import { render, staticRenderFns } from "./ConfigurationHistory.vue?vue&type=template&id=2cd99e18&"
import script from "./ConfigurationHistory.vue?vue&type=script&lang=js&"
export * from "./ConfigurationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports